import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "titleCardEnergy" }
const _hoisted_2 = { class: "subTitleCardEnergy" }
const _hoisted_3 = { class: "subTitleCardEnergy" }
const _hoisted_4 = { class: "subTitleCardEnergy__time" }
const _hoisted_5 = { class: "estadisticsValues" }
const _hoisted_6 = { class: "estadisticsValues" }
const _hoisted_7 = { class: "estadisticsValues" }

import { computed, ref } from 'vue';



export default /*@__PURE__*/_defineComponent({
  __name: 'EnergyView',
  setup(__props) {

const searchByText = ref();
const sitioFilter = ref('Todos los Sitios');
const estadoFilter = ref('Todos los Estados');
const ordenBY = ref('Orden: ID')


const listSitios = ref([ 'Todos los Sitios', 'Campamento', 'Mina Norte', 'Mina Sur', 'Planta A', 'Planta B', 'Subestacion' ]);
const listEstados = ref([ 'Todos los Estados', 'OK', 'WARN', 'ALERT' ]);
const listOrden = ref(['Orden: ID', 'Orden: SOC', 'Orden: PV', 'Orden: Ultimo Dato']);

const COLORSTATUS:any = {
    OK : 'green',
    WARN: 'yellow',
    ALERT: 'red'
}

const HEADER = [    
    { title: 'ID', key: 'name'},
    { title: 'IP', key: 'ip'},
    { title: 'Sitio', key: 'sitio'},
    { title: 'Estado', key: 'estado'},
    { title: 'SOC (%)', key: 'soc'},
    { title: 'Vbat', key: 'vbat'},
    { title: 'Ibat', key: 'ivat'},
    { title: 'PV (W)', key: 'pv'},
    { title: 'AC V', key: 'acv'},
    { title: 'AC W', key: 'acw'},
    { title: 'Alarmas', key: 'estado2'},
    { title: 'Ultimo', key: 'time'},
]

const filteredItems = computed(() => {
  let filtered = [...listITEMS.value]


  if (searchByText.value) {
    const term = searchByText.value.toLowerCase()
    filtered = filtered.filter(item =>
      item.name.toLowerCase().includes(term) ||
      item.ip.toLowerCase().includes(term)
    )
  }


  if (sitioFilter.value !== 'Todos los Sitios') {
    filtered = filtered.filter(item => item.sitio.toLowerCase() === sitioFilter.value.toLowerCase())
  }

  
  if (estadoFilter.value !== 'Todos los Estados') {
    filtered = filtered.filter(item => item.estado.toLowerCase() === estadoFilter.value.toLowerCase())
  }

  
  switch (ordenBY.value) {
    case 'Orden: ID':
      filtered.sort((a, b) => a.name.localeCompare(b.name))
      break
    case 'Orden: SOC':
      filtered.sort((a, b) => parseInt(b.soc) - parseInt(a.soc))
      break
    case 'Orden: PV':
      filtered.sort((a, b) => parseInt(b.pv) - parseInt(a.pv))
      break
    case 'Orden: Ultimo Dato':
      filtered.sort((a, b) => {
        const timeA = parseInt(a.time.replace(/\D/g, ''))
        const timeB = parseInt(b.time.replace(/\D/g, ''))
        return timeA - timeB
      })
      break
  }

  return filtered
})

const listITEMS = ref([
    {
        name: 'cerbo-001',
        sitio : 'mina norte',
        ip: '192.168.0.11',
        fw: 'FW v3.40',
        time: 'hace 9 min',
        soc: '94%',
        vbat: '41.7v',
        pv: '2434 w',
        estado: 'warn',
        estado2: 'AC Facil'
    },
    {
        name: 'cerbo-002',
        sitio : 'mina sur',
        ip: '192.168.0.12',
        fw: 'FW v3.40',
        time: 'hace 4 min',
        soc: '84%',
        vbat: '30.6v',
        pv: '2377 w',
        estado: 'warn',
        estado2: 'AC Facil'
    },
    {
        name: 'cerbo-003',
        sitio : 'mina central',
        ip: '192.168.0.13',
        fw: 'FW v3.41',
        time: 'hace 2 min',
        soc: '76%',
        vbat: '39.2v',
        pv: '2510 w',
        estado: 'ok',
        estado2: 'AC OK'
    },
    {
        name: 'cerbo-004',
        sitio : 'mina norte',
        ip: '192.168.0.14',
        fw: 'FW v3.40',
        time: 'hace 15 min',
        soc: '68%',
        vbat: '37.8v',
        pv: '2011 w',
        estado: 'alert',
        estado2: 'AC Fail'
    },
    {
        name: 'cerbo-005',
        sitio : 'mina sur',
        ip: '192.168.0.15',
        fw: 'FW v3.39',
        time: 'hace 7 min',
        soc: '90%',
        vbat: '42.1v',
        pv: '2765 w',
        estado: 'ok',
        estado2: 'AC OK'
    },
    {
        name: 'cerbo-006',
        sitio : 'mina este',
        ip: '192.168.0.16',
        fw: 'FW v3.40',
        time: 'hace 1 min',
        soc: '58%',
        vbat: '28.4v',
        pv: '1890 w',
        estado: 'alert',
        estado2: 'AC Fail'
    },
    {
        name: 'cerbo-007',
        sitio : 'mina oeste',
        ip: '192.168.0.17',
        fw: 'FW v3.41',
        time: 'hace 10 min',
        soc: '82%',
        vbat: '33.5v',
        pv: '2203 w',
        estado: 'warn',
        estado2: 'AC Facil'
    },
    {
        name: 'cerbo-008',
        sitio : 'mina norte',
        ip: '192.168.0.18',
        fw: 'FW v3.42',
        time: 'hace 3 min',
        soc: '96%',
        vbat: '44.3v',
        pv: '2590 w',
        estado: 'ok',
        estado2: 'AC OK'
    },
    {
        name: 'cerbo-009',
        sitio : 'mina sur',
        ip: '192.168.0.19',
        fw: 'FW v3.38',
        time: 'hace 8 min',
        soc: '71%',
        vbat: '35.0v',
        pv: '2101 w',
        estado: 'warn',
        estado2: 'AC Facil'
    },
    {
        name: 'cerbo-010',
        sitio : 'mina central',
        ip: '192.168.0.20',
        fw: 'FW v3.40',
        time: 'hace 12 min',
        soc: '87%',
        vbat: '38.9v',
        pv: '2294 w',
        estado: 'ok',
        estado2: 'AC OK'
    },
    {
        name: 'cerbo-011',
        sitio : 'mina norte',
        ip: '192.168.0.21',
        fw: 'FW v3.41',
        time: 'hace 6 min',
        soc: '65%',
        vbat: '31.4v',
        pv: '1750 w',
        estado: 'alert',
        estado2: 'AC Fail'
    },
    {
        name: 'cerbo-012',
        sitio : 'mina sur',
        ip: '192.168.0.22',
        fw: 'FW v3.40',
        time: 'hace 9 min',
        soc: '92%',
        vbat: '40.6v',
        pv: '2412 w',
        estado: 'ok',
        estado2: 'AC OK'
    },
    {
        name: 'cerbo-013',
        sitio : 'mina este',
        ip: '192.168.0.23',
        fw: 'FW v3.41',
        time: 'hace 14 min',
        soc: '79%',
        vbat: '36.8v',
        pv: '2175 w',
        estado: 'warn',
        estado2: 'AC Facil'
    },
    {
        name: 'cerbo-014',
        sitio : 'mina oeste',
        ip: '192.168.0.24',
        fw: ' FW v3.39',
        time: 'hace 5 min',
        soc: '88%',
        vbat: '39.9v',
        pv: '2450 w',
        estado: 'ok',
        estado2: 'AC OK'
    },
    {
        name: 'cerbo-015',
        sitio : 'mina norte',
        ip: '192.168.0.25',
        fw: 'FW v3.40',
        time: 'hace 11 min',
        soc: '74%',
        vbat: '34.2v',
        pv: '2120 w',
        estado: 'warn',
        estado2: 'AC Facil'
    },
    {
        name: 'cerbo-016',
        sitio : 'mina central',
        ip: '192.168.0.26',
        fw: 'FW v3.42',
        time: 'hace 13 min',
        soc: '55%',
        vbat: '27.9v',
        pv: '1703 w',
        estado: 'alert',
        estado2: 'AC Fail'
    },
    {
        name: 'cerbo-017',
        sitio : 'mina sur',
        ip: '192.168.0.27',
        fw: 'FW v3.40',
        time: 'hace 2 min',
        soc: '93%',
        vbat: '41.2v',
        pv: '2535 w',
        estado: 'ok',
        estado2: 'AC OK'
    },
    {
        name: 'cerbo-018',
        sitio : 'mina este',
        ip: '192.168.0.28',
        fw: 'FW v3.41',
        time: 'hace 16 min',
        soc: '66%',
        vbat: '32.1v',
        pv: '1984 w',
        estado: 'warn',
        estado2: 'AC Facil'
    },
    {
        name: 'cerbo-019',
        sitio : 'mina oeste',
        ip: '192.168.0.29',
        fw: 'FW v3.40',
        time: 'hace 7 min',
        soc: '81%',
        vbat: '36.0v',
        pv: '2256 w',
        estado: 'ok',
        estado2: 'AC OK'
    },
    {
        name: 'cerbo-020',
        sitio : 'mina norte',
        ip: '192.168.0.30',
        fw: 'FW v3.41',
        time: 'hace 10 min',
        soc: '72%',
        vbat: '33.7v',
        pv: '2054 w',
        estado: 'warn',
        estado2: 'AC Facil'
    },
    {
        name: 'cerbo-021',
        sitio : 'mina sur',
        ip: '192.168.0.31',
        fw: 'FW v3.42',
        time: 'hace 3 min',
        soc: '95%',
        vbat: '43.6v',
        pv: '2689 w',
        estado: 'ok',
        estado2: 'AC OK'
    },
    {
        name: 'cerbo-022',
        sitio : 'mina central',
        ip: '192.168.0.32',
        fw: 'FW v3.39',
        time: 'hace 18 min',
        soc: '60%',
        vbat: '29.3v',
        pv: '1820 w',
        estado: 'alert',
        estado2: 'AC Fail'
    }
])



return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_sheet, {
      color: "transparent",
      class: "ma-4"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, { class: "ma-0" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              class: "pa-4",
              modelValue: searchByText.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchByText).value = $event)),
              label: 'Buscar por ID/IP',
              variant: "underlined",
              density: "compact",
              "hide-details": "",
              style: {"max-width":"200px !important"}
            }, null, 8, ["modelValue"]),
            _createVNode(_component_v_select, {
              class: "pa-4",
              modelValue: sitioFilter.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((sitioFilter).value = $event)),
              items: listSitios.value,
              label: 'Sitio',
              variant: "underlined",
              density: "compact",
              "hide-details": "",
              style: {"max-width":"200px !important"}
            }, null, 8, ["modelValue", "items"]),
            _createVNode(_component_v_select, {
              class: "pa-4",
              modelValue: estadoFilter.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((estadoFilter).value = $event)),
              items: listEstados.value,
              label: 'Estados',
              variant: "underlined",
              density: "compact",
              "hide-details": "",
              style: {"max-width":"200px !important"}
            }, null, 8, ["modelValue", "items"]),
            _createVNode(_component_v_select, {
              class: "pa-4",
              modelValue: ordenBY.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ordenBY).value = $event)),
              items: listOrden.value,
              label: 'Orden',
              variant: "underlined",
              density: "compact",
              "hide-details": "",
              style: {"max-width":"200px !important"}
            }, null, 8, ["modelValue", "items"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_sheet, {
      color: "transparent",
      class: "ma-4"
    }, {
      default: _withCtx(() => [
        _cache[10] || (_cache[10] = _createElementVNode("h2", null, "Resumen por equipos (Tarjetas)", -1)),
        _createVNode(_component_v_row, { class: "ma-0" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredItems.value, (item, i) => {
              return (_openBlock(), _createBlock(_component_v_col, {
                class: "pa-2",
                cols: "2",
                key: i
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_sheet, { class: "energyCardItems" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_1, _toDisplayString(item.name), 1),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        _createElementVNode("span", _hoisted_2, " • " + _toDisplayString(item.sitio), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_3, " IP " + _toDisplayString(item.ip) + " • " + _toDisplayString(item.fw) + " • ", 1),
                        _cache[5] || (_cache[5] = _createTextVNode()),
                        _createElementVNode("span", _hoisted_4, _toDisplayString(item.time), 1)
                      ]),
                      _createVNode(_component_v_row, { class: "ma-0" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            class: "pa-0 pr-1",
                            cols: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_sheet, { class: "cardEstaditics" }, {
                                default: _withCtx(() => [
                                  _cache[6] || (_cache[6] = _createElementVNode("div", null, [
                                    _createElementVNode("span", { class: "estadisticsTitle" }, " SOC ")
                                  ], -1)),
                                  _createElementVNode("div", {
                                    style: _normalizeStyle(`color: ${COLORSTATUS[item.estado.toUpperCase()]};`)
                                  }, [
                                    _createElementVNode("span", _hoisted_5, _toDisplayString(item.soc), 1)
                                  ], 4)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, {
                            class: "pa-0 pl-1",
                            cols: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_sheet, { class: "cardEstaditics" }, {
                                default: _withCtx(() => [
                                  _cache[7] || (_cache[7] = _createElementVNode("div", null, [
                                    _createElementVNode("span", { class: "estadisticsTitle" }, "Vbat")
                                  ], -1)),
                                  _createElementVNode("div", null, [
                                    _createElementVNode("span", _hoisted_6, _toDisplayString(item.vbat), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, {
                            class: "pa-0 mt-2",
                            cols: "12"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_sheet, { class: "cardEstaditics" }, {
                                default: _withCtx(() => [
                                  _cache[8] || (_cache[8] = _createElementVNode("div", null, [
                                    _createElementVNode("span", { class: "estadisticsTitle" }, " PV ")
                                  ], -1)),
                                  _createElementVNode("div", null, [
                                    _createElementVNode("span", _hoisted_7, _toDisplayString(item.pv), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_v_row, { class: "ma-0 mt-2" }, {
                        default: _withCtx(() => [
                          _cache[9] || (_cache[9] = _createElementVNode("span", { class: "titleCardEnergy mt-1 mr-2" }, " Estado: ", -1)),
                          _createVNode(_component_v_chip, {
                            class: "mx-1",
                            variant: "outlined",
                            color: COLORSTATUS[item.estado.toUpperCase()]
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.estado), 1)
                            ]),
                            _: 2
                          }, 1032, ["color"]),
                          _createVNode(_component_v_chip, {
                            class: "mx-1",
                            variant: "outlined",
                            color: 'red'
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.estado2), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_sheet, {
      class: "ma-4",
      color: "transparent"
    }, {
      default: _withCtx(() => [
        _cache[11] || (_cache[11] = _createElementVNode("h2", null, "Tabla de Equipos", -1)),
        (filteredItems.value.length > 0)
          ? (_openBlock(), _createBlock(_component_v_data_table, {
              key: 0,
              headers: HEADER,
              items: filteredItems.value,
              density: "compact",
              hover: ""
            }, null, 8, ["items"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})